import { Parser } from 'hot-formula-parser';

export const getMonthsInYears = (years) => years * 12;

export const getMonthlyRateOfReturn = (annualRate) =>
    parseFloat(annualRate / 12);

export const getTotalInvestment = (monthlyInvestment, time) =>
    Math.round(monthlyInvestment) * time * 12;

export const getTotalReturns = (monthlyInvestment, time, totalAmount) =>
    parseFloat(
        (totalAmount - getTotalInvestment(monthlyInvestment, time)).toFixed(2)
    );

export const getTotalInterest = (loanAmount, time, emi) =>
    parseFloat((emi * time - loanAmount).toFixed(2));

export const getTotalLoanAmount = (loanAmount, interest) =>
    loanAmount + interest;

export const getDownpayment = (loanAmount, downpaymentPercentage) =>
    parseFloat(((downpaymentPercentage / 100) * loanAmount).toFixed(2));

export const getActualLoanAmount = (loanAmount, downpayment) =>
    parseFloat(
        (loanAmount - getDownpayment(loanAmount, downpayment)).toFixed(2)
    );

export const getFDGain = (maturityAmount, totalInvestment) =>
    maturityAmount - totalInvestment;

export const calculateSipTotalCorpus = ({
    monthlyRateOfReturn,
    noOfMonths,
    monthlyInvestment,
}) => {
    const formulaParser = new Parser();
    const totalCorpus = formulaParser.parse(
        `FV(${monthlyRateOfReturn}%, ${noOfMonths}, -${monthlyInvestment}, 0, 1)`
    );
    if (totalCorpus.error) {
        return null;
    }
    return parseFloat(totalCorpus.result.toFixed(2));
};

export const calculateLoanEmi = ({ loanAmount, noOfMonths, rate }) => {
    const formulaParser = new Parser();
    const emi = formulaParser.parse(
        `-PMT(${rate}%/12,${noOfMonths},${loanAmount},0,0)`
    );
    if (emi.error) {
        return null;
    }
    return parseFloat(emi.result.toFixed(2));
};

export const calculateGoalCorpusSip = ({
    expectedReturn,
    noOfMonths,
    goalAmount,
}) => {
    const formulaParser = new Parser();
    const totalCorpus = formulaParser.parse(
        `(${goalAmount}*(${expectedReturn}%/12))/((1+${expectedReturn}%/12)^${noOfMonths}-1)`
    );
    if (totalCorpus.error) {
        return null;
    }
    return parseFloat(totalCorpus.result.toFixed(2));
};

export const calculateFDMaturity = ({
    totalInvestment,
    rate,
    time,
    compoundingFrequency,
}) => {
    return (
        totalInvestment *
        Math.pow(
            1 + rate / (compoundingFrequency * 100),
            compoundingFrequency * time
        )
    );
};
